import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { apiFetchPredesTransactionsReject, apiFetchPredesTransactionsBulkReject } from '../../api/PredesTransactionsRejectAPI';
import {
  PREDES_TRANSACTIONS_BULK_REJECT_REQUEST,
  PREDES_TRANSACTIONS_REJECT_REQUEST,
} from '../actions/types/PredesTransactionsRejectActionsTypes';
import {
  postPredesTransactionsRejectSuccessActionCreator,
  postPredesTransactionsRejectFailureActionCreator,
  postPredesTransactionsBulkRejectFailureActionCreator,
  postPredesTransactionsBulkRejectSuccessActionCreator,
} from '../actions/PredesTransactionsRejectActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doPredesTransactionsRejectWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchPredesTransactionsReject, action.payload);
    yield put(postPredesTransactionsRejectSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.predes.transactions.reject.success'),
    }));
  } catch (error) {
    yield put(postPredesTransactionsRejectFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doPredesTransactionsBulkRejectWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchPredesTransactionsBulkReject, action.payload);
    yield put(postPredesTransactionsBulkRejectSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.predes.transactions.bulk-reject.success'),
    }));
  } catch (error) {
    yield put(postPredesTransactionsBulkRejectFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doPredesTransactionsRejectWatcher() {
  yield takeLatest(PREDES_TRANSACTIONS_REJECT_REQUEST, doPredesTransactionsRejectWorker);
  yield takeLatest(PREDES_TRANSACTIONS_BULK_REJECT_REQUEST, doPredesTransactionsBulkRejectWorker);
}

export default doPredesTransactionsRejectWatcher;
export {
  doPredesTransactionsRejectWorker,
  doPredesTransactionsBulkRejectWorker,
};
